import {
  Modal,
  Radio,
  Switch,
  Button,
  InputNumber,
  Select,
  Tooltip,
  Input,
} from 'antd';
import { Field, Form, Formik } from 'formik';
import { Fragment } from 'react';
import { object } from 'yup';
import { Text } from '.';
import { SingleSelect } from './SingleSelect';
import { classNames } from 'src/utilities';
import TextArea from 'antd/es/input/TextArea';
import { PatternFormat } from 'react-number-format';
import { autoGeneratePractitionerDetailsAction } from '../../store/actions/practitioner.action';
import { SuperAdminTable } from './Table';
import { useDispatch } from 'react-redux';
import { CloseOutlined, PlusOutlined, DeleteOutlined } from '@ant-design/icons';
import { AppointmentType } from 'src/components/baseComponents/AppointmentType';
import { isEmpty } from 'lodash-es';

const { Option } = Select;

const vSchema = object({});
export const SuperAdminModal = ({
  open,
  sections, // Array of sections with headings and fields
  validationSchema = vSchema,
  initialValues,
  className,
  submitButtonText = 'Ok',
  cancelButtonText = 'Cancel',
  handleCancel = () => null,
  handleSubmit,
  customBody,
  additionalBody,
  loading,
  centered,
  handleRadioButton,
  radioButtonValue,
  appointmentTypes,
  closable,
  isShown,
  isOrganizationSelected,
  setStoreMirrorPractitionerId,
  storeOrganizationUuid,
  storeMirrorPractitionerId,
  practitionerOptions,
  columns,
  getTableDataByPractitionerId,
  tableLoader,
  storeConditionId,
  conditionOptions,
  additionalTitleButtonText,
  handleGenerateScript,
  submitLoading,
  fronteggRoleOptions,
}) => {
  const dispatch = useDispatch();
  const allAppointmentTypes = !isEmpty(appointmentTypes)
    ? [...appointmentTypes]
    : [];

  return (
    <Formik
      initialValues={{
        ...initialValues,
      }}
      validationSchema={validationSchema}
      enableReinitialize
      onSubmit={handleSubmit}
    >
      {({
        errors,
        touched,
        resetForm,
        setFieldValue,
        values,
        setFieldTouched,
        validateForm,
      }) => {
        const handleFormSubmit = async (e) => {
          e.preventDefault();

          sections?.forEach((section) => {
            section.fields?.forEach((field) => {
              if (field.name) {
                setFieldTouched(field.name, true);
              }
            });
          });

          const validationErrors = await validateForm();

          if (validationErrors && Object.keys(validationErrors).length > 0) {
            return;
          }

          handleSubmit(values);
        };

        return (
          <Modal
            mask={true}
            open={open}
            onCancel={handleCancel}
            closable={closable}
            afterClose={() => resetForm()}
            className={classNames(`custom-modal`, className ? className : '')}
            centered={centered}
            footer={null}
            maskClosable={false}
          >
            <div className="modal_background">
              <Form onSubmit={handleFormSubmit} autoComplete="off">
                {sections?.map((section, index) => (
                  <div className="modal__header" key={`section-${index}`}>
                    <div className="modal__header mb-3">
                      {section.heading === 'radio_group' ? (
                        <>
                          <div className="flex">
                            {/* <div className=""> Add condition </div> */}
                            <div className="flex items-center">
                              <span className="">
                                <Radio.Group
                                  onChange={(e) => {
                                    handleRadioButton(e);
                                  }}
                                  value={radioButtonValue}
                                >
                                  {appointmentTypes.map((item) => (
                                    <AppointmentType
                                      key={item.value}
                                      item={item}
                                      appointmentTypes={allAppointmentTypes}
                                    />
                                  ))}
                                </Radio.Group>
                              </span>
                            </div>
                          </div>
                        </>
                      ) : (
                        section.heading
                      )}
                    </div>
                    <div className="modal____body">
                      {customBody ? (
                        customBody
                      ) : (
                        <div className={section.className}>
                          {section.fields.map(
                            (
                              {
                                type,
                                name,
                                title,
                                helperTitle,
                                options,
                                placeholder,
                                onChange,
                                disabled,
                                className,
                                dropdownArrow,
                                extraIcon,
                                dropdownMode,
                                disabledField,
                                inputClassName,
                                ...props
                              },
                              fieldIndex
                            ) => (
                              <Fragment key={`${name}-${fieldIndex}`}>
                                <div
                                  className={`${className} modal__form-el`}
                                  key={name}
                                >
                                  <div className="flex justify-between items-center mb-1">
                                    <Text
                                      type="p"
                                      className={`modal__form-el-label ${
                                        touched[name] && errors[name]
                                          ? 'error'
                                          : ''
                                      }`}
                                    >
                                      {title}
                                    </Text>
                                    {type === 'modalTextArea' &&
                                      additionalTitleButtonText && (
                                        <Button
                                          className="ih-button-primary ml-2"
                                          loading={loading}
                                          onClick={handleGenerateScript}
                                        >
                                          {additionalTitleButtonText}
                                        </Button>
                                      )}
                                  </div>

                                  {type === 'add_mirror_user' ? (
                                    <Select
                                      id="mirror_user"
                                      bordered={false}
                                      placeholder="Select user"
                                      showSearch
                                      optionFilterProp="label"
                                      className="user-placeholder-select border-none w-full font-sans items-center focus:outline-none h-12 ring-1 ring-[#E0E8EB] rounded-xl bg-white"
                                      disabled={!isOrganizationSelected}
                                      onChange={(e) => {
                                        if (e !== undefined && e !== null) {
                                          // Filter reset for condition based on mirror practitioner id : Start
                                          if (
                                            storeConditionId.length > 0 ||
                                            storeConditionId.length === 0
                                          ) {
                                            setFieldValue('condition_id', '');
                                          }
                                          // End
                                          setStoreMirrorPractitionerId(e);
                                          dispatch(
                                            autoGeneratePractitionerDetailsAction(
                                              e,
                                              storeOrganizationUuid,
                                              setFieldValue,
                                              conditionOptions,
                                              fronteggRoleOptions
                                            )
                                          );
                                        } else {
                                          setStoreMirrorPractitionerId(null);
                                        }
                                      }}
                                      value={
                                        storeMirrorPractitionerId || undefined
                                      }
                                      allowClear={{
                                        clearIcon: (
                                          <CloseOutlined className="text-gray-700 hover:text-gray-700 transition-colors duration-200" />
                                        ),
                                      }}
                                      filterOption={(input, option) =>
                                        option.label
                                          .toLowerCase()
                                          .includes(input.toLowerCase())
                                      }
                                    >
                                      {practitionerOptions.map((option) => (
                                        <Option
                                          key={option.value}
                                          value={option.value}
                                          label={option.label}
                                        >
                                          <Tooltip
                                            placement="right"
                                            title={
                                              <div className="w-[40rem]">
                                                <div className="ant-table h-96 overflow-auto">
                                                  <SuperAdminTable
                                                    className="appointment-page-table"
                                                    columns={columns}
                                                    data={getTableDataByPractitionerId(
                                                      option.value
                                                    )}
                                                    loading={tableLoader}
                                                  />
                                                </div>
                                              </div>
                                            }
                                          >
                                            {option.label}
                                          </Tooltip>
                                        </Option>
                                      ))}
                                    </Select>
                                  ) : type === 'switch' ? (
                                    <Text
                                      type="label"
                                      className="modal__form-el-label mb-2"
                                    >
                                      {helperTitle}
                                      <Switch
                                        className="mx-3"
                                        key={name}
                                        checked={isShown}
                                        style={{ backgroundColor: '#00000040' }}
                                        onChange={
                                          onChange
                                            ? (value, option) => {
                                                onChange(
                                                  value,
                                                  option,
                                                  setFieldValue
                                                );
                                              }
                                            : () => null
                                        }
                                      />
                                    </Text>
                                  ) : type === 'select' ? (
                                    <SingleSelect
                                      name={name}
                                      options={options}
                                      placeholder={placeholder}
                                      disabled={disabled}
                                      className={`single-select ${
                                        touched[name] && errors[name]
                                          ? 'error'
                                          : ''
                                      }`}
                                      popupClassName={props?.popupClassName}
                                      onChange={
                                        onChange
                                          ? (value, option) => {
                                              onChange(
                                                setFieldValue,
                                                value,
                                                option
                                              );
                                            }
                                          : () => null
                                      }
                                      value={values[name]}
                                      dropdownArrow={dropdownArrow}
                                      error={touched[name] && errors[name]}
                                      extraIcon={extraIcon}
                                      dropdownMode={dropdownMode}
                                      inputClassName={inputClassName}
                                    />
                                  ) : type === 'label' ? (
                                    <div className="modal__form-el">
                                      <Text className={``}>{title}</Text>
                                    </div>
                                  ) : type === 'radio' ? (
                                    <div>
                                      {options.map((option) => (
                                        <label
                                          key={option.value}
                                          className="modal__form-el-radio"
                                        >
                                          <Field
                                            type="radio"
                                            name={name}
                                            value={option.value}
                                          />
                                          {option.label}
                                        </label>
                                      ))}
                                    </div>
                                  ) : type === 'modalTextArea' ? (
                                    <div
                                      className={`modal__form-el-field-textarea border rounded-xl p-2 bg-white ${
                                        touched[name] && errors[name]
                                          ? 'border-[#c70039]'
                                          : 'border-[#e5e8eb]'
                                      }`}
                                    >
                                      <TextArea
                                        name={name}
                                        placeholder={placeholder}
                                        value={values[name]}
                                        onChange={(e) =>
                                          setFieldValue(name, e.target.value)
                                        }
                                        onBlur={(e) => {
                                          if (e.target.value === '') {
                                            setFieldTouched(name, true);
                                          }
                                        }}
                                        style={{
                                          resize: 'none',
                                          fontSize: '14px',
                                          fontWeight: 400,
                                        }}
                                        bordered={false}
                                        className={`${
                                          touched[name] && errors[name]
                                            ? 'error'
                                            : ''
                                        }`}
                                        autoSize={{ minRows: 3, maxRows: 13 }}
                                        disabled={disabled}
                                      />
                                    </div>
                                  ) : type === 'jsonTextArea' ? (
                                    <div
                                      className={`modal__form-el-field-Json-textarea border rounded-xl ${
                                        touched[name] && errors[name]
                                          ? 'border-[#c70039]'
                                          : 'border-[#e5e8eb]'
                                      }`}
                                    >
                                      <TextArea
                                        key={name}
                                        name={name}
                                        placeholder={placeholder}
                                        value={values[name]}
                                        onChange={(e) => {
                                          const value = e.target.value;
                                          try {
                                            JSON.parse(value);
                                            setFieldValue(name, value);
                                          } catch (err) {
                                            setFieldValue(name, value);
                                          }
                                        }}
                                        onBlur={(e) => {
                                          const { value } = e.target;
                                          setFieldTouched(name, true);
                                          try {
                                            JSON.parse(value);
                                            setFieldValue(name, value);
                                          } catch (err) {
                                            setFieldValue(name, value);
                                          }
                                        }}
                                        style={{
                                          resize: 'none',
                                          fontSize: '14px',
                                          fontWeight: 400,
                                        }}
                                        bordered={false}
                                        className={`modal__form-el-field-Json-textarea border rounded-xl ${
                                          touched[name] && errors[name]
                                            ? 'error'
                                            : ''
                                        }`}
                                        readOnly={disabledField}
                                      />
                                    </div>
                                  ) : type === 'text' ? (
                                    <Field
                                      className={`modal__form-el-field ${
                                        touched[name] && errors[name]
                                          ? 'error'
                                          : ''
                                      }`}
                                      key={name}
                                      name={name}
                                      disabled={disabled}
                                      onChange={
                                        onChange
                                          ? (e) => {
                                              onChange(setFieldValue, e);
                                            }
                                          : (e) => {
                                              setFieldValue(
                                                name,
                                                e?.target?.value
                                              );
                                            }
                                      }
                                      placeholder={placeholder}
                                      value={values[name] || ''}
                                      role="presentation"
                                      autoComplete="off"
                                    />
                                  ) : type === 'phonenumber_text' ? (
                                    <PatternFormat
                                      className={`modal__form-el-field ${
                                        touched[name] && errors[name]
                                          ? 'error'
                                          : ''
                                      }`}
                                      key={name}
                                      type={type}
                                      name={name}
                                      disabled={disabled}
                                      placeholder={placeholder}
                                      {...props}
                                      format="(###) ###-####"
                                      allowEmptyFormatting={false}
                                      value={values[name] || ''}
                                      autoComplete="off"
                                      role="presentation"
                                      onValueChange={(values) => {
                                        if (onChange) {
                                          onChange(values.value, setFieldValue);
                                          setFieldValue(name, values.value);
                                        } else {
                                          setFieldValue(name, values.value);
                                        }
                                      }}
                                    />
                                  ) : type === 'InputNumber' ? (
                                    <InputNumber
                                      key={name}
                                      type={type}
                                      name={name}
                                      min={0}
                                      placeholder={placeholder}
                                      bordered={false}
                                      disabled={disabled}
                                      onBlur={(e) => {
                                        if (e === '') {
                                          setFieldTouched(name, true);
                                        }
                                      }}
                                      value={values[name] ?? ''}
                                      onChange={
                                        onChange
                                          ? (e) => {
                                              onChange(setFieldValue, e);
                                            }
                                          : () => null
                                      }
                                      className={`modal__form-el-field ${
                                        touched[name] && errors[name]
                                          ? 'error'
                                          : ''
                                      }`}
                                    />
                                  ) : type === 'number' ? (
                                    <Field
                                      className={`modal__form-el-field ${
                                        touched[name] && errors[name]
                                          ? 'error'
                                          : ''
                                      }`}
                                      key={name}
                                      type={type}
                                      name={name}
                                      disabled={disabled}
                                      placeholder={placeholder}
                                      {...props}
                                      value={values[name] || ''}
                                      role="presentation"
                                      autoComplete="off"
                                    />
                                  ) : type === 'keyValueTextArea' ? (
                                    <div className="key-value-textarea">
                                      {Object.entries(
                                        JSON.parse(values[name] || '{}')
                                      ).map(([key, value], index) => (
                                        <div
                                          key={index}
                                          className="key-value-pair flex items-start mb-2"
                                        >
                                          <Input
                                            className="key-input mr-2 w-1/3"
                                            value={key}
                                            onChange={(e) => {
                                              const newObj = {
                                                ...JSON.parse(values[name]),
                                              };
                                              const oldValue = newObj[key];
                                              delete newObj[key];
                                              newObj[e.target.value] = oldValue;
                                              setFieldValue(
                                                name,
                                                JSON.stringify(newObj)
                                              );
                                            }}
                                          />
                                          <TextArea
                                            className="value-textarea flex-grow"
                                            value={value}
                                            onChange={(e) => {
                                              const newObj = {
                                                ...JSON.parse(values[name]),
                                              };
                                              newObj[key] = e.target.value;
                                              setFieldValue(
                                                name,
                                                JSON.stringify(newObj)
                                              );
                                            }}
                                            autoSize={{
                                              minRows: 10,
                                              maxRows: 10,
                                            }}
                                          />
                                          <Button
                                            icon={<DeleteOutlined />}
                                            onClick={() => {
                                              const newObj = {
                                                ...JSON.parse(values[name]),
                                              };
                                              delete newObj[key];
                                              setFieldValue(
                                                name,
                                                JSON.stringify(newObj)
                                              );
                                            }}
                                            className="ml-2"
                                          />
                                        </div>
                                      ))}
                                      <Button
                                        icon={<PlusOutlined />}
                                        onClick={() => {
                                          const newObj = {
                                            ...JSON.parse(values[name] || '{}'),
                                          };
                                          newObj[
                                            `newKey${Object.keys(newObj).length}`
                                          ] = '';
                                          setFieldValue(
                                            name,
                                            JSON.stringify(newObj)
                                          );
                                        }}
                                        className="mt-2"
                                      >
                                        Add Key
                                      </Button>
                                    </div>
                                  ) : (
                                    <Field
                                      className={`modal__form-el-field ${
                                        touched[name] && errors[name]
                                          ? 'error'
                                          : ''
                                      }`}
                                      key={name}
                                      type={type}
                                      name={name}
                                      disabled={disabled}
                                      placeholder={placeholder}
                                      {...props}
                                      value={values[name] || null}
                                      role="presentation"
                                      autoComplete="off"
                                    />
                                  )}

                                  {touched[name] && errors[name] && (
                                    <Text type={'error'} className={'error'}>
                                      {errors[name]}
                                    </Text>
                                  )}
                                </div>
                              </Fragment>
                            )
                          )}
                        </div>
                      )}
                    </div>
                  </div>
                ))}
                {additionalBody ? additionalBody : ''}
                <div className="flex justify-end gap-3 modal__form-footer">
                  {cancelButtonText && (
                    <div className="">
                      <Button
                        loading={loading}
                        className="ih-button-secondary"
                        onClick={() => handleCancel()}
                      >
                        {cancelButtonText}
                      </Button>
                    </div>
                  )}
                  {submitButtonText && (
                    <div className="inline-block">
                      <Button
                        className={'ih-button-primary'}
                        htmlType="submit"
                        loading={submitLoading}
                      >
                        {submitButtonText}
                      </Button>
                    </div>
                  )}
                </div>
              </Form>
            </div>
          </Modal>
        );
      }}
    </Formik>
  );
};
